module.exports = __webpack_public_path__ + "static/media/container-1638068-modified-reduced-60.3824d918.jpg";